import { siteConfig, siteUrl } from './site';

/** paydirt vertical — domain/branding for this deployment (not platform). */
export const paydirtConfig = {
  verticalId: 'paydirt',
  brandName: process.env.NEXT_PUBLIC_SITE_NAME || 'Paydirt Social',
  tagline:
    'Where rockhounders, gold panners, and gem enthusiasts share their finds, compare hauls, and compete with the community.',
  claimDefinition:
    'A claim is your report of what you recovered from paydirt you bought or dug — not a legal mining claim.',
  claimCtaLabel: 'Make a claim',
  haulReports: {
    label: 'Haul reports',
    description: 'Search and browse community haul reports.',
    path: '/claims/',
  },
  leaderboard: {
    label: 'Leaderboard',
    description: 'Top haul ROI reports from the community.',
    path: '/leaderboard/',
  },
  forum: {
    label: 'Forum',
    description: 'General discussion about prospecting, gear, and the community.',
    path: '/forum/',
    defaultSubSlug: 'general',
  },
  groups: {
    label: 'Groups',
    description: 'Prospector communities — link haul reports and discuss finds together.',
    path: '/groups/',
  },
  feedback: {
    label: 'Platform feedback',
    description: 'Suggest improvements, report bugs, and vote on what we build next.',
    path: '/feedback/',
  },
  blog: {
    label: 'Blog',
    description: 'Long-form stories and guides from the community.',
    path: '/blog/',
  },
  calendar: {
    label: 'Calendar',
    description: 'Community events and important dates.',
    path: '/calendar/',
  },
  siteUrl: siteConfig.siteUrl,
  get domain(): string {
    try {
      return new URL(siteConfig.siteUrl).hostname;
    } catch {
      return '';
    }
  },
  vendorMode: { enabled: true },
  claimEvidenceGuidance: {
    sectionIntro:
      'Help the community verify your haul. Photos are optional, but haul reports with clear evidence get approved faster. Show your scale at zero with your empty container, and add a photo for each find so others can confirm weight and material.',
    scaleZeroLabel: 'Scale zero photo (optional)',
    scaleZeroHelper: 'Photo of your scale reading 0 with the empty container you use for weighing.',
    findPhotoLabel: 'Find photo (optional)',
    findPhotoHelper: 'A clear photo of this find helps the community confirm your report.',
    reviewNoPhotos:
      'No photo evidence yet — you can still publish, but community approval is harder without photos.',
    reviewHasPhotos: 'Evidence attached — voters can verify your finds.',
  },
  apiBaseUrl: siteConfig.apiBaseUrl,
  mapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY || '',
  assets: {
    mainPageBackdrop: '/backdrops/gold-panning-adventure.webp',
    icon: '/brand/icon.png',
    icon192: '/brand/icon-192.png',
    appleTouchIcon: '/brand/apple-touch-icon.png',
    ogIcon: '/brand/og-icon.png',
  },
};

export type PaydirtConfig = typeof paydirtConfig;

export { siteUrl as absoluteSiteUrl };
